import React, { ReactNode } from "react";
interface StepHeadingProps {
  title: ReactNode;
  description?: ReactNode;
}
export function StepHeading({
  title,
  description
}: StepHeadingProps) {
  return <div className="mb-7" data-id="element-933" data-mp="32ajnn0l5xu0a">
      <h1 className="text-[28px] font-bold leading-[1.1] tracking-[-0.02em] text-ink md:text-[40px]" data-id="element-934" data-mp="32at9cbz6df06">{title}</h1>
      {description && <p className="mt-3 max-w-[56ch] text-[15px] leading-relaxed text-ink-2 md:text-base" data-id="element-935" data-mp="2y9g8kgaxw204">{description}</p>}
    </div>;
}